import PhoneInputModule, { type CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import pl from 'react-phone-input-2/lang/pl.json'
import ua from "./countries/ua.json";
import "./CustomPhoneInput.scss";
import { useTranslation } from "react-i18next";
import { languages } from "../../i18n/i18n.constants";

// Rolldown (Vite 8) doesn't unwrap __esModule CJS default exports for webpack bundles
const PhoneInput = (PhoneInputModule as { default?: typeof PhoneInputModule }).default ?? PhoneInputModule;

interface Props {
    value?: string | null;
    name: string;
    isDisable?: boolean;
    isValid?: boolean;
    isInvalid?: boolean;
    errors?: string;
    onChange?(
        value: string,
        data: CountryData | unknown,
        event: React.ChangeEvent<HTMLInputElement>,
        formattedValue: string
    ): void;
    onBlur?(event: React.FocusEvent<HTMLInputElement>, data: CountryData | unknown): void;
}

const CustomPhoneInput = ({ value, name, isDisable, isValid, isInvalid, onChange, onBlur, errors }: Props) => {
    const { i18n } = useTranslation();
    const mapLangCodeToTranslateSource = (langCode: string) => {
        switch (langCode) {
            case languages.en:
                return {};
            case languages.pl:
                return pl;
            case languages.uk:
                return ua;
            default:
                return {}
        }
    }
    return (
        <>
            <PhoneInput
                localization={mapLangCodeToTranslateSource(i18n.language)}
                enableSearch={true}
                specialLabel=""
                country={"ua"}
                regions={"europe"}
                inputClass={`w-100${isInvalid ? " is-invalid" : ""}${isValid ? " is-valid" : ""}`}
                value={value}
                disabled={isDisable}
                onChange={onChange}
                onBlur={onBlur}
                inputProps={{
                    name,
                    id: name,
                    "aria-label": "phone number"
                }}
            />
            {isInvalid ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                    {errors}
                </div>
            ) : null}
        </>
    );
};

export default CustomPhoneInput;
